import { Button } from '@/components/Button';
import { EUserFlow, selectPurchasePrice } from '@/context/borrower';
import {
    EModals,
    selectUserFlow,
    setDisplay,
    setModal,
} from '@/context/display';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { selectIsLoggedIn } from '@/context/user';
import { loanGetNextScreen } from '@/utils/loanGetNextScreen';

interface Props {
    baseId: string;
}

export function NoLenderHomeButtons({ baseId }: Props): JSX.Element {
    const dispatch = useAppDispatch();
    const purchasePrice = useAppSelector(selectPurchasePrice);
    const userFlow = useAppSelector(selectUserFlow);
    const isLoggedIn = useAppSelector(selectIsLoggedIn);

    async function handleClick(): Promise<void> {
        if (!purchasePrice) {
            return;
        }
        if (userFlow === EUserFlow.NO_LENDER_EARLY_SIGNUP && !isLoggedIn) {
            dispatch(setModal(EModals.REGISTER));
            return;
        }
        const nextScreen = loanGetNextScreen();
        dispatch(setDisplay(nextScreen));
    }

    return (
        <Button
            onClick={handleClick}
            title='Get Personalised Quote'
            id={`${baseId}button-getQuoteNow`}
        />
    );
}
